"use client";
import React, { useEffect, useState } from "react";

import Skeleton from "react-loading-skeleton";
import Calculator from "@/components/Calculator";
import InquiryButton from "@/components/Inquiry/Button";

import { useProductVariableStore } from "@/lib/store/product-variable.store";
import { useProductAttributeStore } from "@/lib/store/product-attribute.store";
import { useShoppingCart } from "@/lib/hooks/useShoppingCart";
import { useUserStore } from "@/store/user.store";
import { setInquiry } from "@/lib/utils/util";
import { useShoppingCartStore } from "@/lib/store/shoppingCart";
import { useRouter } from "@/navigation";
import { useUserAuth } from "@/lib/hooks/useUserAuth";
import { App } from "antd";
import { IconLove } from "./product-card";
import clsx from "clsx";
import Svg from "../Header/Menu/Svg";
import { useCompareStore } from "@/lib/store/Compare.store";
import CompareList from "../CompareList";
import { useLoveStore } from "@/lib/store/love.store";
import Price from "../Price/price";
import { useTranslations } from "next-intl";
import { LoadingOutlined } from "@ant-design/icons";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";
import ModalInquiryButton from "./ModalInquiryButton";
export default function ProductCartBuyInquiry(props?: any) {
	const isProps = !!Object?.keys(props!)?.length;
	const [count, setCount] = useState(1);
	const { addToCart, createBuyBowCheckout } = useShoppingCart();
	let { userInfo } = useUserStore();
	const { currentProduct } = useProductVariableStore();
	const { selectAttribute } = useProductAttributeStore();
	const [minQuantity, setMinQuantity] = useState(-1);
	const [loading, setLoading] = useState(false);
	const t = useTranslations("message");
	const tNav = useTranslations("nav");
	const tCommon = useTranslations("common");

	//Inquiryloading
	const [Inquiryloading, setInquiryloading] = useState(false);

	//Cartloading
	const [Cartloading, setCartloading] = useState(false);

	//Buy Bowloading
	const [BuyBowloading, setBuyBowloading] = useState(false);

	const { setisCart, BuyBowcheckoutId, BuyBowCartList } = useShoppingCartStore() as any;
	let { compareIds, show, changeShow, setcCmpareProducts } = useCompareStore();
	const { isLogin } = useUserAuth();
	const { openModalInquiry } = useModalInquiryContext();
	const { loveIds, setLoveProducts } = useLoveStore();
	let router = useRouter();
	// 将 message 替换为 App.useApp()
	const { message } = App.useApp();

	// 添加询盘
	async function AddInquiry() {
		if (!props.VariantActive) return;
		setInquiryloading(true);
		// @ts-ignore
		setTimeout(() => {
			setInquiry(props.product, count, props.VariantActive.name);
			message.success(t("inquiryAddedSuccess"));

			return setInquiryloading(false);
		}, 2000);
	}

	// 添加购物车
	async function AddCart() {
		if (!props.VariantActive?.pricing?.price.gross.amount) {
			return message.error(t("Thecurrent1234234"));
		}
		// if (!isLogin()) {
		//   const login = document.querySelector("#web-login") as HTMLLIElement;
		//   return  login.click();
		// };
		if (!props.VariantActive) return;
		setCartloading(true);
		// @ts-ignore
		await addToCart({
			channel: "default-channel",
			selectedVariantID: props.VariantActive.id,
			quantity: count,
		});
		setCartloading(false);
	}

	//立即购买Buy Bow
	async function BuyBow() {
		if (!props.VariantActive?.pricing?.price.gross.amount) {
			return message.error(t("Thecurrent1234234"));
		}
		// if (!isLogin()) {
		//   const login = document.querySelector("#web-login") as HTMLLIElement;
		//   return  login.click();
		// };
		if (!props.VariantActive) return;
		setBuyBowloading(true);
		// @ts-ignore
		let bool = await createBuyBowCheckout({
			channel: "default-channel",
			selectedVariantID: props.VariantActive.id,
			quantity: count,
		});
		setBuyBowloading(false);
		setisCart(false);
		if (bool) {
			router.push("/checkout");
		}
	}

	// 添加对比
	const addOrDelCompare = (event: React.MouseEvent, product) => {
		event.stopPropagation();

		const id = product?.id;
		if (id) {
			setcCmpareProducts(id);
			changeShow(true);
		}
	};

	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = props.product.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<>
			<div className="mt-5">
				{!isProps ? (
					<>
						<div className="s-flex gap-x-4">
							<Skeleton
								width={220}
								height={60}
								style={{
									borderRadius: "15px",
								}}
							></Skeleton>
							<Skeleton
								width={220}
								height={60}
								style={{
									borderRadius: "15px",
								}}
							></Skeleton>
						</div>
					</>
				) : (
					<div className="flex  flex-wrap justify-start gap-x-4 gap-y-4">
						{/* <InquiryButton count={count} id={props!.databaseId.toString()} />  */}
						<div className="flex flex-1  flex-col gap-y-4">
							{/* <div className="font-abeezee flex items-center  gap-2 ">
								<p className="!text-[16px]">Sub total:</p>
								<p className="!text-[18px] text-[#1e1e1e] ">
									<Price price={props?.VariantActive?.pricing.price.gross.amount * count || ""} />
								</p>
							</div> */}
							<div className="!flex  w-full flex-wrap gap-4">
								{/* <div className={clsx("!flex gap-4", process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && "w-full")}>
									<Calculator
										initCount={minQuantity > 0 ? minQuantity : 1}
										className="h-[30px] w-[45px]"
										changeCount={setCount}
										disabled={false}
										minCount={minQuantity > 0 ? minQuantity : 1}
										maxCount={props?.variations ? currentProduct?.stockQuantity : props?.stockQuantity}
									/>
									{process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && (
										<InquiryButton
											className="!font-poppins !w-full !rounded-sm border-[1px] border-main !bg-main  !px-3  !py-2 !text-white  hover:!bg-white hover:!text-main"
											VariantActive={props.VariantActive}
											count={count}
											id={props.id}
											text={"form.Buy Now"}
											product={props.product}
											loading={BuyBowloading}
											callback={BuyBow}
										/>
									)}
								</div> */}

								{/* Web端布局：保持原有样式 */}
								<div className="hidden md:flex w-full flex-col gap-5">
									{/* Web端：Calculator、购物车、询盘和比较按钮在同一行 */}
									<div className="flex w-full items-center gap-5">
										{/* <Calculator
											initCount={minQuantity > 0 ? minQuantity : 1}
											className="h-[30px] w-[45px]"
											changeCount={setCount}
											disabled={false}
											minCount={minQuantity > 0 ? minQuantity : 1}
											maxCount={props?.variations ? currentProduct?.stockQuantity : props?.stockQuantity}
										/> */}
										{process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && (
											<InquiryButton
												className="!font-poppins !flex-1 !rounded-sm border-[1px] border-black !bg-white !px-3 !py-2 !text-black hover:!bg-main hover:!text-white hover:border-main"
												VariantActive={props.VariantActive}
												count={count}
												id={props.id}
												text={"form.Add To Cart"}
												product={props.product}
												loading={Cartloading}
												callback={AddCart}
											/>
										)}
										<div className="flex gap-4">
											<div
												onClick={AddInquiry}
												className={clsx(
													"group flex h-[52px] min-w-[120px] rounded-lg cursor-pointer items-center justify-center gap-2 border-[1px] px-3 transition-all duration-300",
													Inquiryloading
														? "border-mainColor bg-mainColor"
														: "border-mainColor bg-white hover:bg-mainColor hover:border-mainColor"
												)}
											>
												{Inquiryloading ? (
													<>
														<LoadingOutlined className="!text-white" />
													</>
												) : (
													<>
														<i className={clsx("ri-add-line text-mainColor text-[22px] group-hover:text-white transition-colors duration-300")}></i>
														<span className="text-sm font-medium text-mainColor group-hover:text-white transition-colors duration-300">{tCommon("Add to Inquiry")}</span>
													</>
												)}
											</div>
											<div
												onClick={(e) => addOrDelCompare(e, props.product)}
												className={clsx(
													"group flex h-[52px] min-w-[120px] cursor-pointer items-center justify-center gap-2 rounded-lg border-[1px] px-3 transition-all duration-300",
													compareIds.includes(props.product.id)
														? "border-mainColor bg-mainColor"
														: "border-mainColor bg-white hover:bg-mainColor hover:border-mainColor"
												)}
											>
												{compareIds.includes(props.product.id) ? (
													<>
														<i className={clsx("ri-check-line text-white text-[22px]")}></i>
														<span className="text-sm font-medium text-white">{tNav("Add to Compare")}</span>
													</>
												) : (
													<>
														<i className={clsx("ri-scales-line ri-xl text-mainColor group-hover:text-white transition-colors duration-300")}></i>
														<span className="text-sm font-medium text-mainColor group-hover:text-white transition-colors duration-300">{tNav("Add to Compare")}</span>
													</>
												)}
											</div>
										</div>
									</div>
									{/* ModalInquiryButton */}
									<div className="w-[80%]">
										<ModalInquiryButton
											className="!font-poppins flex w-full cursor-pointer items-center justify-center !rounded-lg  !bg-mainColor !px-3 !py-2 text-[16px] !text-white hover:!bg-mainColor/80"
											VariantActive={props.VariantActive}
											count={count}
											id={props.id}
											product={props.product}
											locale={props.locale}
											buttonText={t("Inquiry Now")}
										/>
									</div>
								</div>

								{/* 移动端布局：每个按钮单独一行 */}
								<div className="flex md:hidden w-full flex-col gap-5">
									{/* Calculator 单独一行 */}
									{/* <div className="flex w-full">
										<Calculator
											initCount={minQuantity > 0 ? minQuantity : 1}
											className="h-[30px] w-[45px]"
											changeCount={setCount}
											disabled={false}
											minCount={minQuantity > 0 ? minQuantity : 1}
											maxCount={props?.variations ? currentProduct?.stockQuantity : props?.stockQuantity}
										/>
									</div> */}
									
									{/* 购物车按钮单独一行 */}
									{process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && (
										<div className="flex w-full">
											<InquiryButton
												className="!font-poppins !flex-1 !rounded-sm border-[1px] border-black !bg-white !px-3 !py-2 !text-black hover:!bg-main hover:!text-white hover:border-main text-sm"
												VariantActive={props.VariantActive}
												count={count}
												id={props.id}
												text={"form.Add To Cart"}
												product={props.product}
												loading={Cartloading}
												callback={AddCart}
											/>
										</div>
									)}
									
									{/* 询盘按钮单独一行 */}
									<div className="flex w-full">
										<div
											onClick={AddInquiry}
											className={clsx(
												"group flex h-[52px] w-full cursor-pointer items-center justify-center gap-2 rounded-sm border-[1px] px-3 transition-all duration-300",
												Inquiryloading
													? "border-mainColor bg-mainColor"
													: "border-mainColor bg-white hover:bg-mainColor hover:border-mainColor"
											)}
										>
											{Inquiryloading ? (
												<>
													<LoadingOutlined className="!text-white" />
												</>
											) : (
												<>
													<i className={clsx("ri-add-line text-mainColor text-[22px] group-hover:text-white transition-colors duration-300")}></i>
													<span className="text-sm font-medium text-mainColor group-hover:text-white transition-colors duration-300">{tCommon("Add to Inquiry")}</span>
												</>
											)}
										</div>
									</div>
									
									{/* 比较按钮单独一行 */}
									<div className="flex w-full">
										<div
											onClick={(e) => addOrDelCompare(e, props.product)}
											className={clsx(
												"group flex h-[52px] w-full cursor-pointer items-center justify-center gap-2 rounded-sm border-[1px] px-3 transition-all duration-300",
												compareIds.includes(props.product.id)
													? "border-mainColor bg-mainColor"
													: "border-mainColor bg-white hover:bg-mainColor hover:border-mainColor"
											)}
										>
											{compareIds.includes(props.product.id) ? (
												<>
													<i className={clsx("ri-check-line text-white text-[22px]")}></i>
													<span className="text-sm font-medium text-white">{tNav("Add to Compare")}</span>
												</>
											) : (
												<>
													<i className={clsx("ri-scales-line ri-xl text-mainColor group-hover:text-white transition-colors duration-300")}></i>
													<span className="text-sm font-medium text-mainColor group-hover:text-white transition-colors duration-300">{tNav("Add to Compare")}</span>
												</>
											)}
										</div>
									</div>

									{/* ModalInquiryButton */}
									<div className="w-full">
										<ModalInquiryButton
											className="!font-poppins flex w-full cursor-pointer items-center justify-center !rounded-sm border-[1px] border-black !bg-mainColor !px-3 !py-2 text-[16px] !text-white hover:!bg-mainColor/80 text-sm"
											VariantActive={props.VariantActive}
											count={count}
											id={props.id}
											product={props.product}
											locale={props.locale}
											buttonText={t("Inquiry Now")}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			<div className="max-md:hidden">
				<CompareList />
			</div>
		</>
	);
}
